import React from "react";
import style from "./style.module.css";
import * as Animate from "react-reveal";

const ListItem = ({ title, content }) => {
  return (
    <li className="flex flex-row items-start">
      <div className="">
        <svg
          width="13"
          height="15"
          viewBox="0 0 13 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.48971 0.807129L11.6164 1.9464C11.9016 2.01004 12.105 2.26273 12.105 2.55535V8.78641C12.105 10.038 11.4792 11.2072 10.4379 11.901L6.48971 14.5333L2.54156 11.901C1.49962 11.2066 0.874451 10.038 0.874451 8.78704V2.55535C0.874451 2.26273 1.07785 2.01004 1.36298 1.9464L6.48971 0.807129ZM6.48971 2.08554L2.12229 3.05573V8.78641C2.12229 9.62059 2.53906 10.3999 3.23348 10.8628L6.48971 13.034L9.74594 10.8628C10.4404 10.3999 10.8571 9.62122 10.8571 8.78704V3.05573L6.48971 2.08616V2.08554ZM9.2674 5.31306L10.1502 6.19528L6.17963 10.1659L3.53234 7.51861L4.41456 6.63639L6.179 8.40083L9.2674 5.31244V5.31306Z"
            fill="#08A05C"
          />
        </svg>
      </div>

      <div className="pl-4 -mt-1">
        <p className="text-base lg:text-lg text-primary font-mono font-medium">
          {title}
        </p>
        <p className="mt-2 text-sm-15 lg:text-base">{content}</p>
      </div>
    </li>
  );
};

const EligibilitySection = () => {
  return (
    <section className="relative pt-20 lg:pt-24 pb-20 md:pb-28 lg:pb-32">
      <div className="relative container mx-auto px-4">
        <div className="w-full lg:w-10/12 mx-auto">
          <Animate.Fade bottom>
            <h3 className="w-full lg:w-7/12 mx-auto font-semibold text-3xl md:text-3xl lg:text-4xl xl:text-5xl xl:leading-snug text-primary text-center font-mono">
              <span className={`${style.gradentText}`}>Are You Eligible?</span>
            </h3>
            <p className="w-full lg:w-7/12 mx-auto text-center mt-6 lg:mt-8 text-base lg:text-lg">
              If you are excited about the digital disruptions taking place
              across the globe, are between 18 and 35 years old, and are looking
              to gain specialized skills that will help you break into a
              high-income, globally-relevant tech career, this is for you
            </p>
          </Animate.Fade>

          <div
            className={`${style.card} mt-20 lg:mt-24 rounded-2xl px-6 lg:px-10 py-8 lg:py-12`}
          >
            <div className="">
              <Animate.Fade left>
                <ul className="list-inside text-sm-15 lg:text-base grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-14 ">
                  <ListItem
                    title="Age"
                    content={"Between 18 and 35 years of age"}
                  />
                  <ListItem
                    title="Geography"
                    content={"Open for all African Youth."}
                  />
                  <ListItem
                    title="Career Status"
                    content={
                      "Recent graduates, young professionals, entrepreneurs, and anyone looking to gain the skills to transform their future."
                    }
                  />
                </ul>
              </Animate.Fade>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilitySection;
